import { useEffect } from "react";

const characters = "0123456789abcdefghijklmnopqrstuvwxyz";
const numbers = "0123456789";
const scrambleInterval = 95;
const cycleDuration = 2400;

const randomCharacter = (characterSet = characters) =>
  characterSet[Math.floor(Math.random() * characterSet.length)];

const getGlyphs = (progress: number) => {
  if (progress < 0.3) {
    return `${randomCharacter(numbers)}${randomCharacter(numbers)}`;
  }

  if (progress < 0.6) {
    return `${randomCharacter()}${randomCharacter()}`;
  }

  if (progress < 0.82) {
    return `a${randomCharacter()}`;
  }

  return "a_";
};

const drawFavicon = (
  context: CanvasRenderingContext2D,
  canvas: HTMLCanvasElement,
  glyphs: string
) => {
  const size = canvas.width;

  context.clearRect(0, 0, size, size);
  context.fillStyle = "#0a0a09";
  context.beginPath();
  context.roundRect(1.5, 1.5, size - 3, size - 3, 11);
  context.fill();

  context.strokeStyle = "#292927";
  context.lineWidth = 1.5;
  context.stroke();

  context.fillStyle = "#ebebe7";
  context.font = '500 29px "Commit Mono", "SFMono-Regular", monospace';
  context.textAlign = "center";
  context.textBaseline = "middle";
  context.fillText(glyphs, size / 2, size / 2 - 1);
};

const AnimatedFavicon = () => {
  useEffect(() => {
    const favicon = document.querySelector<HTMLLinkElement>('link[rel="icon"]');

    if (!favicon) {
      return;
    }

    const fallbackHref = favicon.href;
    const canvas = document.createElement("canvas");
    const context = canvas.getContext("2d");
    const prefersReducedMotion = window.matchMedia(
      "(prefers-reduced-motion: reduce)"
    ).matches;

    canvas.width = 64;
    canvas.height = 64;

    if (!context) {
      return;
    }

    let timeout = 0;
    const startTime = performance.now();

    const render = (glyphs: string) => {
      drawFavicon(context, canvas, glyphs);
      favicon.href = canvas.toDataURL("image/png");
    };

    const animate = () => {
      const now = performance.now();
      const progress = ((now - startTime) % cycleDuration) / cycleDuration;

      render(getGlyphs(progress));
      timeout = window.setTimeout(animate, scrambleInterval);
    };

    if (prefersReducedMotion) {
      render("a_");
    } else {
      animate();
    }

    return () => {
      window.clearTimeout(timeout);
      favicon.href = fallbackHref;
    };
  }, []);

  return null;
};

export default AnimatedFavicon;
